// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type SaveGlobalPlanConstraintItemMutationVariables = Types.Exact<{
  input: Types.SaveGlobalPlanConstraintItemInput;
}>;


export type SaveGlobalPlanConstraintItemMutation = { __typename?: 'Mutation', saveGlobalPlanConstraintItem: { __typename?: 'SaveGlobalPlanConstraintItemResult', globalPlanConstraintItem: { __typename?: 'GlobalPlanConstraintItem', id: string } } };


export const SaveGlobalPlanConstraintItemDocument = gql`
    mutation SaveGlobalPlanConstraintItem($input: SaveGlobalPlanConstraintItemInput!) {
  saveGlobalPlanConstraintItem(input: $input) {
    globalPlanConstraintItem {
      id
    }
  }
}
    `;
export type SaveGlobalPlanConstraintItemMutationFn = Apollo.MutationFunction<SaveGlobalPlanConstraintItemMutation, SaveGlobalPlanConstraintItemMutationVariables>;

/**
 * __useSaveGlobalPlanConstraintItemMutation__
 *
 * To run a mutation, you first call `useSaveGlobalPlanConstraintItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveGlobalPlanConstraintItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveGlobalPlanConstraintItemMutation, { data, loading, error }] = useSaveGlobalPlanConstraintItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveGlobalPlanConstraintItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveGlobalPlanConstraintItemMutation, SaveGlobalPlanConstraintItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveGlobalPlanConstraintItemMutation, SaveGlobalPlanConstraintItemMutationVariables>(SaveGlobalPlanConstraintItemDocument, options);
      }
export type SaveGlobalPlanConstraintItemMutationHookResult = ReturnType<typeof useSaveGlobalPlanConstraintItemMutation>;
export type SaveGlobalPlanConstraintItemMutationResult = Apollo.MutationResult<SaveGlobalPlanConstraintItemMutation>;
export type SaveGlobalPlanConstraintItemMutationOptions = Apollo.BaseMutationOptions<SaveGlobalPlanConstraintItemMutation, SaveGlobalPlanConstraintItemMutationVariables>;